import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, PreviewAltCard, Row } from "../../components/Component";
import { Badge, Form, Offcanvas, OffcanvasBody, OffcanvasHeader, Spinner } from "reactstrap";

import { toast } from "react-toastify";

import Status from "../../MyComp/UI/form/Status";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyInput from "../../MyComp/UI/form/MyInput";
import { createBannerAPI, listBannerAPI, updateBannerAPI } from "../../api/master/indes";
import { BASE_URL_IMG } from "../../assets/constants";
import useLogout from "../../hooks/useLogout";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import MyCreateSelect from "../../MyComp/UI/form/MyCreateSelect";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import Table from "../../MyComp/UI/DataTable/Table";
const BannerList = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
getValues,
    clearErrors,

    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
    },
  });
  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);

  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetF();
  };

  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const selectorDeleteUser = () => setData(data.filter((d) => !d.checked));

  useEffect(() => {
    getBannerList();
  }, []);

  const getBannerList = () => {
    listBannerAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) { 
          setData(res.data.data);
          setValue("isLoading", false);
        } else {
          setData([]);
          setValue("isLoading", false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };
  const onFormSubmit = (data) => {
    const formData = new FormData();
    formData.append("order", watch("order"));
    formData.append("banner_alt", watch("banner_alt"));
    formData.append("status", watch("status")?.value);
    formData.append(
      "meta_keywords",
      watch("meta_keywords")?.map((item) => item.value)
    );
    const i = watch("banner_img");
    if (data?.banner_img) {
      console.log("uploaded");
      formData.append("banner_img", i);
    }
    if (mode == "Edit") {
      formData.append("id", watch("selectedRow")?.id);
    }
    if (mode == "Add") {
      createBannerAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getBannerList();
            setIsOpen(false);
            setValue("isLoading", false);
            resetF();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
    if (mode == "Edit") {
      updateBannerAPI(formData)
        .then((res) => {
          //const status = decrypt(res.data.status);
          if (res.data.status === true) {
            toast.success(res.data.message);
            toast.clearWaitingQueue();
            getBannerList();
            setIsOpen(false);
            setValue("isLoading", false);
            resetF();
          } else if (res.data.status === false) {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
          } else if (res.data.status === "expired") {
            setValue("isLoading", false);
            toast.error(res.data.message);
            toast.clearWaitingQueue();
            logout();
          }
        })
        .catch((err) => {
          setValue("isLoading", false);
          toast.error(err?.response?.data?.message);
        });
    }
  };
  const resetF = () => {
    setMode("Add");
    setValue("banner_image", null);
    setValue("banner_alt", "");
    setValue("meta_keywords", "");
    setValue("status", null);
    setValue("banner_img", null);
    setValue("order", "");
    setValue("selectedRow", "");
  };
  const handleEdit = (row) => {
    window.scrollTo(0, 0);

    setValue("selectedRow", row);
    setIsOpen(true);
    setMode("Edit");
    setValue("banner_alt", row?.image_alt);
    const imageUrl = `${BASE_URL_IMG}${row.banner_image}`;
    setValue("banner_image", imageUrl); //image_url value
    setValue("order", row?.order);
    setValue("status", {
      label: row.status ? "Active" : "InActive",
      value: row.status,
    });
    if (row?.meta_tags) {
      const tagArray = row.meta_tags.split(",").map((tag) => {
        const trimmed = tag.trim();
        return {
          label: trimmed,
          value: trimmed,
        };
      });

      setValue("meta_keywords", tagArray);
    }
  };
  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };
  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };
  const confirmStatusChange = (data) => {
    const updatedStatus = watch("selectedRow").status === true ? false : true;
    setValue("isLoading", true);
    const formObject = {
      id: watch("selectedRow").id,
      status: updatedStatus,
    };
    updateBannerAPI(formObject)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          getBannerList();
          setIsOpen(false);
          setValue("isLoading", false);
          setShowModal(false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };
  const selectorSuspendUser = () => setData(data.map((d) => (d.checked ? { ...d, status: false } : d)));

  return (
    <>
      <Head title={"Product | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <>
            {" "}
            <div className="container my-5 text-center">
              {/* Button to open offcanvas */}

              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}>Banner </OffcanvasHeader>
                <OffcanvasBody>
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Banner Alt"}
                            name={"banner_alt"}
                            placeholder={"Enter banner alt"}
                            required
                            min={2}
                            max={50}
                          />
                        </Col>
                        <Col md="12">
                          <ImageUpload
                            id="banner_image"
                            watch={watch}
                            label={"Upload Banner Image"}
                            errors={errors}
                            register={register}
                            trigger={trigger}
                            clearErrors={clearErrors}
                            image={"banner_img"}
                            image_url={"banner_image"}
                            setValue={setValue}
                            handleImageOpenPreview={handleImageOpenPreview}
                            required
                            getValues={getValues}
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Order"}
                            name={"order"}
                            placeholder={"Enter category order"}
                            required
                            min={1}
                            max={2}
                          />
                        </Col>
                        <Col md="12" className={``}>
                          <MyCreateSelect
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Keywords"}
                            name={"meta_keywords"}
                            placeholder={"Create meta keywords"}
                            required
                            multi
                          />
                        </Col>
                        <Col md={`12`}>
                          <Status
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                          />
                        </Col>
                      </Row>
                      <Col md="12" className={``}>
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <MyButton isLoading={isLoading} mode={mode} />
                        </div>
                      </Col>
                    </Form>
                  </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>

              {/* Offcanvas (Right Side) */}
            </div>
          </>

          <Table
            title="Banner List"
            data={data}
            publicButton={false}
            columns={[
              { key: "banner_image", label: "Name", type: "image" },
              // { key: "image_alt", label: "Banner Alt" },
              { key: "order", label: "Order" },
              { key: "meta_tags", label: "Meta" },
            ]}
            searchKeys={["name", "order", "meta_tags"]}
            nameColumn={"image_alt"}
            imageBaseURL={BASE_URL_IMG}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            selectorDeleteUser={selectorDeleteUser}
            selectorSuspendUser={selectorSuspendUser}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={resetF}
            handleImageOpenPreview={handleImageOpenPreview}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            handleTogglePublish={handleTogglePublish}
          />

          {/* <MyDataTable data={data || []} columns={column} title={"Product List"} isLoading={isLoading} /> */}
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default BannerList;
